export const HOLD_LOCK_CONFIRM_TIME = 30 * 60 * 1000; // 30 minutes

export const QUESTION_VERSIONS = {
  NONE: 'NONE',
  ORIGINAL: 'ORIGINAL',
  UPDATED: 'UPDATED'
};
